// request.js
import axios from 'axios';
import router from '../router';
import { Message } from 'element-ui';

let baseUrl;
let adminApi;
if(process.env.NODE_ENV === 'production'){
    baseUrl =  process.env.VUE_APP_BASE_URL
    adminApi = process.env.VUE_APP_ADMIN_API
}else{
    baseUrl = '/baseUrl'
    adminApi = '/adminApi'
}

// 刷新 token 的 URL（根据您的实际情况调整）
const refreshTokenUrl = `${baseUrl}/system/auth/refresh-token`;

// 全局变量用于控制刷新状态
let isRefreshing = false;  // 是否正在刷新 token
let requests = [];        // 存储待重发的请求队列

const request = axios.create({
    timeout: 60000
});

// 独立的刷新 token 请求实例（避免拦截器死循环）
const refreshRequest = axios.create({
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
});

request.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 请求拦截器
request.interceptors.request.use(
    config => {
        if (localStorage.getItem('Authorization')) {
            config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('Authorization');
        }
        config.headers['tenant-id'] = '1';
        return config;
    },
    error => {
        console.log(error, '请求拦截错误');
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    response => {
        if (response.status === 200) {
            const res = response.data;
            if (res.code === 0) {
                return response.data;
            } else if (res.code === 401) {
                handleUnauthorized();
            } else {
                // 其他错误处理
                if (res.ResultCode !== 0 && res.msg) {
                    Message.warning(res.msg);
                }
                return response.data;
            }
        }
        return response.data;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    return handleUnauthorized(error.config);
                case 400:
                    // 处理其他状态码
                    break;
                case 403:
                case 404:
                case 500:
                case 502:
                default:
                    // 其他错误处理
                    break;
            }
        }
        return Promise.reject(error.response);
    }
);

// 处理 401 未授权的通用函数
function handleUnauthorized(originalRequest) {
    console.log(originalRequest,'originalRequest')
    // 没有 originalRequest 表示来自业务代码的 401
    if (!originalRequest) {
        redirectToLogin();
        return Promise.reject('未授权');
    }

    // 检查是否有 refresh token
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
        redirectToLogin();
        return Promise.reject('无刷新令牌');
    }

    // 如果正在刷新 token，将当前请求加入队列
    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            requests.push(() => {
                originalRequest.headers.Authorization = 'Bearer ' + localStorage.getItem('Authorization');
                resolve(request(originalRequest));
            });
        });
    }

    // 设置刷新状态
    isRefreshing = true;
    
    return new Promise((resolve, reject) => {
        // 发送刷新 token 请求
        refreshRequest.post(refreshTokenUrl, { refreshToken })
            .then(response => {
                const { data } = response;
                if (data.code === 0) {
                    // 更新 token
                    const newToken = data.data.accessToken;
                    localStorage.setItem('Authorization', newToken);
                    localStorage.setItem('refreshToken', data.data.refreshToken);

                    // 更新原始请求的 header
                    originalRequest.headers.Authorization = 'Bearer ' + newToken;
                    
                    // 处理队列中的请求
                    requests.forEach(cb => cb());
                    requests = [];
                    
                    // 重新发送原始请求
                    resolve(request(originalRequest));
                } else {
                    // 刷新 token 失败
                    throw new Error('刷新 token 失败');
                }
            })
            .catch(err => {
                console.error('刷新 token 错误:', err);
                redirectToLogin();
                reject(err);
            })
            .finally(() => {
                isRefreshing = false;
            });
    });
}

// 跳转到登录页
function redirectToLogin() {
    localStorage.removeItem('Authorization');
    localStorage.removeItem('refreshToken');
    Message.warning('登录已过期，请重新登录');
    router.push('/');
}

export default request;